module.exports = __webpack_public_path__ + "img/apartment-red.5b7c34d0.png";